export const init = () => { 
    if (document.querySelector('.s-new-features-header')) {
        // console.log('run'); 
        const actionSearch = document.querySelectorAll('.s-new-features-header__search .js-action');  
        const searchContent = document.querySelector('.js-s-new-features-header__search-content');   

        // console.log(actionSearch);  
        
        actionSearch.forEach((item) => {
            item.addEventListener('click', function(e) {
                // console.log('run');
                e.preventDefault(); 
                item.classList.remove('active'); 
            
                switch(item.dataset.action) {
                    case 'activate-search':
                      actionSearch[1].classList.add('active');
                      searchContent.classList.add('active'); 
                      break;
                    case 'close-search':
                      actionSearch[0].classList.add('active');
                      searchContent.classList.remove('active');
                      break;
                  }
                
            })  
        })  
    }   
};